/*
 *
 * Theme: `@dbh/carousel`.
 *
 */const THEME_KEY_CAROUSEL="carousel";const modifyCarouselTheme=a=>{let{colors:{white:b,greyLight:c,grey:d},spacing:{sp3:e,sp4:f}}=a;return {[THEME_KEY_CAROUSEL]:{borderRadius:"0",palette:{idle:b,disabled:c,selected:b,textColor:d},indicators:{dimension:e,margin:"0px "+f+" 0px 0px"},frame:{// Default blocked pointer and user select for performance reasons,
// use `styled(Frame)` to override it.
pointerEvents:"none",padding:0,xs:{width:"100%"},sm:{width:"100%"},md:{width:"100%"},lg:{width:"100%"}}}}};

export { THEME_KEY_CAROUSEL, modifyCarouselTheme as default };
